import { Button, Tag } from "antd";
import { scrollableLayoutOffset, sidebarWidth } from "../constants";
import styled from "styled-components";

export const TopRightButton = styled(Button)`
  position: absolute;
  top: 0;
  left: calc(100vw - ${scrollableLayoutOffset});
  transform: translateX(-100%);

  @media (min-width: 768px) {
    left: calc(100vw - ${sidebarWidth} - ${scrollableLayoutOffset});
  }
`;

export const InnerLoaderWrapper = styled.div`
  > div {
    position: absolute;
    opacity: 0.8;
    z-index: 10;
    height: 100%;
  }
`;

export const StyledTag = styled(Tag)<{ $textColor: string }>`
  &.ant-tag {
    color: ${(props) => props.$textColor};
  }
`;
